<template>
  <Layout>
    <PageHeader :title="title" :items="braedcrumb" />
    <b-overlay :show="show">
      <b-card>
        <b-row>
          <b-col sm="12" md="6" lg="4">
            <b-input-group>
              <b-form-input v-model="filter.providertin"></b-form-input>
              <b-input-group-append>
                <b-button
                  variant="primary"
                  @click="$refs['Providerref'].Refresh()"
                >
                  {{ $t("search") }}
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="8"
            class="text-right d-flex justify-content-end"
          >
            <b-button variant="danger" @click="$router.back()">
              {{ $t("back") }}
            </b-button>
          </b-col>
        </b-row>

        <b-row class="mt-3" v-if="!!filter.providerid || !!filter.providertin">
          <b-col>
            <provider-card
              ref="Providerref"
              :providerid="filter.providerid"
              :providertin="filter.providertin"
            ></provider-card>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </Layout>
</template>

<script>
import Layout from "@/router/layouts/main";
import ProviderCard from "@/components/ProviderCard.vue";
import PageHeader from "@/components/page-header";
export default {
  components: { Layout, ProviderCard, PageHeader },
  data() {
    return {
      show: false,
      title: this.$t("ProviderCard"),
      braedcrumb: [
        {
          text: this.$t("Document")
        },
        {
          text: this.$t("ProviderCard"),
          active: true
        }
      ],
      filter: {
        providerid: 0,
        providertin: ""
      }
    };
  },
  created() {
    this.filter.providerid = this.$route.query.providerid || 0;
    this.filter.providertin = this.$route.query.providertin;
  }
};
</script>

<style></style>
